const InsufficientScore = ({ logoAlt, moduleCertification }) => {
    const defaultLogo = require('../../../images/icon.png');
    return (
        <div className='w30 df aife jcfe'>
            {moduleCertification == 'Bronze' && <div className="trophy-cup ribbon ribbon-bottom-right bronze"><img className="h4rem" src={require(`../../../images/bronze-cup.png`)} alt="" /></div>}
            {moduleCertification == 'Silver' && <div className="trophy-cup ribbon ribbon-bottom-right silver"><img className="h4rem" src={require(`../../../images/silver-cup.png`)} alt="" /></div>}
            {moduleCertification == 'Gold' && <div className="trophy-cup ribbon ribbon-bottom-right gold"><img className="h4rem" src={require(`../../../images/gold-cup.png`)} alt="" /></div>}
            {
                moduleCertification == 'None' ? <div
                    className='br10px bg1 p0-5rem bo4 bss bw1px df fdc aife jcc pr'
                    style={{ width: '70px', height: '70px' }}
                >
                    <img src={defaultLogo} alt={logoAlt} width={15} height={12} className='mb0-5rem pa' style={{ right: "4px", top: "4px" }} />
                    <h2 className='c4 fw600 fs10px tac' style={{ marginTop: '4px' }}>
                        Insufficient Score
                    </h2>
                </div> : null
            }

        </div>
    )
}

export default InsufficientScore